import type { OAuthButtonsTranslations } from "./pl";

export const de: OAuthButtonsTranslations = {
  dividerOr: "oder",
  facebookButton: "Mit Facebook anmelden",
  signingIn: "Anmeldung läuft…",
  facebookCancelled: "Facebook-Anmeldung wurde abgebrochen.",
  facebookFailed: "Facebook-Anmeldung fehlgeschlagen.",
  googleFailed: "Google-Anmeldung fehlgeschlagen.",
};
